import { ListingPatternModel } from '../../../apis/listingsEndpoints';

export interface PatternsState {
  items: ListingPatternModel[];
}

export const initialListingPatternsState: Readonly<PatternsState> = {
  items: []
};
